<template>
    <div v-if="!isCollapse" class="breadcrumb">
    </div>
</template>

<script>
export default {
    name: "Breadcrumb",
    data() {
        return {
        }
    },
    computed: {
    },
    methods: {
    }
};
</script>

<style scoped>
</style>